import type { Control } from 'react-hook-form'

import { ButtonSelectFormField } from 'src/shared/components/ui/forms/form-fields/button-select'
import { clientTypeMap } from 'src/shared/schemas/referrals'

import { expertiseMap } from '../../../schemas/expertise'
import type { SearchFilters } from '../../../schemas/marketplace/filters'
import type { Profession } from '../../../schemas/profession'

type FiltersListProps = {
  selectedProfession: Profession | null
  control: Control<SearchFilters>
}

const FiltersList = ({ selectedProfession, control }: FiltersListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {selectedProfession === 'real_estate_agent' && (
        <ButtonSelectFormField
          control={control}
          name="clientFocus"
          label="Focus"
          labelClassName="text-sm font-semibold text-primary"
          textClassName="text-[12px] xs:text-sm font-semibold"
          allowDeselect={false}
          gridCols={3}
          options={clientTypeMap}
          buttonClassName="text-white bg-primary rounded-[12px] border-none h-[50px] min-h-12"
          unselectedButtonClassName="text-primary bg-[#F8F7F5] rounded-[12px] border-none"
          fieldClassName="gap-[10px]"
        />
      )}
      <ButtonSelectFormField
        control={control}
        name="expertise"
        label="Expertise"
        labelClassName="text-sm font-semibold text-primary"
        textClassName="text-[12px] xs:text-sm font-semibold"
        allowDeselect={false}
        gridCols={2}
        options={selectedProfession ? expertiseMap[selectedProfession] : expertiseMap['mortgage_loan_officer']}
        buttonClassName="text-white bg-primary rounded-[12px] border-none h-[50px] min-h-12"
        unselectedButtonClassName="text-primary bg-[#F8F7F5] rounded-[12px] border-none"
        fieldClassName="gap-[10px]"
        multiSelect
      />
    </div>
  )
}

export default FiltersList
